export default __webpack_public_path__ + "static/media/subscribe-button.bf5c0664.svg";